import { render } from "./Index.vue?vue&type=template&id=5cd14aff&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5cd14aff&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd14aff"]])

export default __exports__